import React, { useEffect } from 'react';
import { createUseStyles } from 'react-jss';
import { Button } from 'antd';
import { useHistory } from 'react-router-dom';
import { FullscreenSpin } from '../components/FullscreenSpin';
import { theme } from '../constants/theme';
import { useAppDispatch, useAppSelector } from '../hooks/store';
import { assignOrganizationType, fetchCurrentUser } from '../slices/auth';
import {
  trackViewSignupChoice,
  trackClickSignupChoice,
} from '../utils/analytics';

const useStyles = createUseStyles({
  container: {
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    flexDirection: 'column',
    width: '100dvw',
    maxWidth: '100%',
    maxHeight: '100%',
    height: '100dvh',
  },
  bgImage: {
    width: '912px',
    height: '921px',
    top: '0px',
    right: '0px',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `url("/images/signup/signupFirstStepBackground.png")`,
    position: 'absolute',
    zIndex: -1,
    overflow: 'hidden',
  },
  left: {
    marginRight: '710px',
    marginLeft: '4dvw',
  },
  sp: {
    fontWeight: '600',
    fontSize: '44px',
    lineHeight: '54px',
    color: theme.palette.primary,
  },
  par: {
    color: 'black',
    fontWeight: '400',
    fontSize: '34px',
    lineHeight: '54px',
    width: '670px',
    marginTop: '114px',
  },
  btngroup: {
    marginTop: '20px',
    display: 'flex',
    flexDirection: 'row',
    gap: '20px',
  },
  button: {
    height: '3vw',
    fontSize: '0.8vw',
    border: `1px solid ${theme.palette.primary}`,
    backgroundColor: 'white',
    color: theme.palette.primary,
    borderRadius: '4px',
    '&:hover': {
      border: `1px solid ${theme.palette.primary}`,
      backgroundColor: theme.palette.primary,
      color: 'white',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.25)',
    },
  },
});

interface Props {
  setIsNavBarHidden?: (isNavBarHidden: boolean) => void;
}

export const ChooseNgoOrDonor: React.VFC<Props> = ({ setIsNavBarHidden }) => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const history = useHistory();

  const { user } = useAppSelector(({ auth: { user } }) => ({
    user,
  }));

  useEffect(() => {
    if (setIsNavBarHidden) {
      setIsNavBarHidden(true);
    }
    trackViewSignupChoice();
  }, []);

  useEffect(() => {
    fetchCurrentUser();
  }, [user]);

  if (!user) {
    return <FullscreenSpin />;
  }

  return (
    <div className={classes.container}>
      <div className={classes.bgImage} />
      <div className={classes.left}>
        <div className={classes.par}>
          <span className={classes.sp}>Un seul lieu</span> pour concrétiser des
          projets, pour se trouver{' '}
          <span className={classes.sp}>autour du mécénat.</span>
        </div>
        <div style={{ width: '476px' }}>
          <div
            style={{
              fontWeight: '400',
              fontSize: '34px',
              marginTop: '153px',
              lineHeight: '54px',
            }}
          >
            Je m&apos;inscris en tant que
          </div>
          <div className={classes.btngroup}>
            <Button
              type="primary"
              className={classes.button}
              style={{
                width: '226px',
                height: '78px',
                fontSize: '18px',
                lineHeight: '18px',
              }}
              onClick={() => {
                trackClickSignupChoice('Porteur de projet');
                dispatch(
                  assignOrganizationType({
                    updateUserDto: { organisationType: 'PROJECT_HOLDER' },
                  }),
                ).then((action: { payload: any }) => {
                  if (action.payload) {
                    history.push('/NgoFirstSteps');
                  }
                });
              }}
            >
              Porteur de projet
            </Button>
            <Button
              type="primary"
              className={classes.button}
              style={{
                width: '226px',
                height: '78px',
                fontSize: '18px',
                lineHeight: '18px',
              }}
              onClick={() => {
                trackClickSignupChoice('Mécène');
                dispatch(
                  assignOrganizationType({
                    updateUserDto: { organisationType: 'MECENE' },
                  }),
                ).then((action: { payload: any }) => {
                  if (action.payload) {
                    history.push('/DonorFirstSteps');
                  }
                });
              }}
            >
              Mécène
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
